export enum ProjectType
{
	Default = 0,
	Administrative = 1,
	Team = 2
}